module.exports = __webpack_public_path__ + "static/img/C01-人大附中深圳学校.d1f1dcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/C01-人大附中深圳学校.png
// module id = RyXw
// module chunks = 0